/// <reference lib="dom" />
import { installDevHelpers } from "./_devmode.js";

function autoExpandLinkedSummary() {
  let hash = window.location.hash;
  if (!hash) return;

  let elt = document.querySelector(`details${hash}`);
  if (elt) {
    elt.setAttribute("open", "");
  }
}

addEventListener("load", autoExpandLinkedSummary);
installDevHelpers();
